import Tabs from "@/components/common/Tabs";
import Promo from "@/components/layout/bonus/Promo";
import PromoProgress from "@/components/layout/bonus/PromoProgress";
import Rank from "@/components/layout/bonus/Rank";
import RankProgress from "@/components/layout/bonus/RankProgress";
import WeeklyProgress from "@/components/layout/bonus/WeeklyProgress";
import PromoThailand from "@/components/layout/home/PromoThailand";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Bonus = () => {
  const { t } = useTranslation();

  type TabKey = "promo" | "grand_promo" | "rank";
  const [activeTab, setActiveTab] = useState<TabKey>("promo");

  const tabs = [
    { value: "promo", label: t("bonus-page.tabs.promo") },
    { value: "grand_promo", label: t("bonus-page.tabs.grand_promo") },
    { value: "rank", label: t("bonus-page.tabs.rank") },
  ];

  return (
    <div className="flex flex-col items-center gap-3 px-4 pb-40">
      <WeeklyProgress />

      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={(val) => setActiveTab(val as TabKey)}
      />

      {activeTab === "promo" && (
        // <div className="flex flex-col items-center gap-4 p-4 rounded-xl bg-white">
        //   <Icon type="loading" className="w-8 h-8 fill-link animate-spin" />
        //   <p className="font-semibold text-center">
        //     Promo results are currently being processed
        //   </p>
        // </div>
        <>
          <PromoProgress />
          <Promo />
        </>
      )}

      {activeTab === "grand_promo" && <PromoThailand />}

      {activeTab === "rank" && (
        <>
          <RankProgress />
          <Rank />
        </>
      )}
    </div>
  );
};

export default Bonus;
